import React from 'react';
// logic
// components
import useQuoteFormSettings from '../components/quoteForm/useQuoteFormSettings';
import NewQuoteToolbar from '../components/newQuote/newQuoteToolbar';
import QuoteForm from '../components/quoteForm/quoteForm';
import PortalContent from '../components/ui/portal/portalContent';
import BasicLoader from '../components/ui/loaders/basicLoader';
import PremiumSectionContainer from '../components/ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../components/ticketForm/components/PremiumSection';
import { InfoMessage } from '../components/ticketForm/components/InfoMessage';
import useQuoteDetail from '../components/quoteDetail/useQuoteDetail';

const QuoteDetailPage = ({ ...props }) => {
  const ticketId = props.match.params.id;
  const quoteId = props.match.params.quoteId;
  const { isLoadingQuoteFormSettings, quoteFormSettings } = useQuoteFormSettings();

  const {
    onSubmit,
    onCancel,
    onAcceptQuote,
    onRejectQuote,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isStateEdit,
    isLoadingTicketDetail,
    ticketDetail,
    ticketDetailError,
    quoteDetail,
    isLoadingQuoteDetail,
    quoteDetailError,
  } = useQuoteDetail({
    quoteId,
    ticketId,
  });

  const quoteFormData = {
    quoteFormSettings,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isStateEdit,
    onSubmit,
    onCancel,
    onAcceptQuote,
    onRejectQuote,
    ticketDetail,
    quoteDetail,
  };

  const isPageReady =
    !isLoadingTicketDetail && !isLoadingQuoteFormSettings && !isLoadingQuoteDetail;
  const is404Error = ticketDetailError?.code === 404 || quoteDetailError?.code === 404;
  const customerName = ticketDetail?.shipper_data?.company_name;

  return (
    <>
      <PortalContent>
        <NewQuoteToolbar id={ticketId} customerName={customerName} ticketDetail={ticketDetail} />
      </PortalContent>
      {!isPageReady ? (
        <BasicLoader />
      ) : ticketDetailError || quoteDetailError ? (
        <PremiumSectionContainer>
          <PremiumSection>
            <InfoMessage>
              {is404Error ? 'Quote not found' : 'There was an error loading the quote'}
            </InfoMessage>
          </PremiumSection>
        </PremiumSectionContainer>
      ) : (
        <>
          <QuoteForm quoteFormData={quoteFormData} />
        </>
      )}
    </>
  );
};

export default QuoteDetailPage;
